import {Component, OnDestroy, OnInit} from '@angular/core'
import {ActivatedRoute, ParamMap, Router} from '@angular/router'
import {switchMap} from 'rxjs/operators'
import {ChangeService} from '../../services/change.service'
import {ObservableInput, of} from 'rxjs'
import {ConfigDetail} from '../../common/domain/config'
import {ToastrService} from 'ngx-toastr'
import {jsonataEditorOptions, jsonEditorOptions, jsonSchemaEditorOptions, xmlEditorOptions} from '../../util/editor-configurations'

@Component({
  selector: 'app-config-edit',
  templateUrl: './config-edit.component.html',
  styleUrls: ['./config-edit.component.scss'],
})
export class ConfigEditComponent implements OnInit, OnDestroy {
  config: ConfigDetail

  private repository: string
  private type: string
  editorOptions: any
  editorValue: any
  originalLineCount: any;
  newLinesCount: any;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private changeService: ChangeService,
    private toast: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(
      switchMap((params: ParamMap): ObservableInput<ConfigDetail> => {
          this.repository = params.get('repository')
          this.type = params.get('type')
          const path = params.get('path')
          const name = path.replace(/^.*\/(.*?)$/, '$1')
          const changed = this.changeService.getChange(path)
          const original = this.changeService.getOriginal(path)
          return of(changed || original || {
            source: this.repository,
            name: name,
            path: path,
            content: '',
            size: 0,
          } as ConfigDetail)
        },
      ),
    ).subscribe(config => {
      this.config = config
      this.editorValue = config.content
      if (config.path.includes('transforms/') && config.name.endsWith('.json')) {
        this.editorOptions = jsonataEditorOptions
      } else if (config.path.includes('schemas/') && config.name.endsWith('.json')) {
        this.editorOptions = jsonSchemaEditorOptions
      } else if (config.name.endsWith('.xsd') || config.name.endsWith('.xslt') || config.name.endsWith('.xml')) {
        this.editorOptions = xmlEditorOptions
      } else {
        this.editorOptions = jsonEditorOptions
      }
    })
    if (this.editorValue) {
      this.getLineCount('original');
    }
  }

  ngOnDestroy(): void {
  }

  cancel() {
    this.toast.warning('Config editing cancelled.')
    this.router.navigate(['config', this.type])
  }

  save(config: ConfigDetail, editorContents: string) {
    const item = Object.assign({}, config, {content: editorContents})
    this.changeService.addChange(item)
    this.toast.info('Config updated.')
    this.router.navigate(['config', this.type])
  }

  getLineCount(value?: string) {
    setTimeout(() => {
      monaco.editor.getModels().filter(v => {
        if (value === 'original') {
          this.originalLineCount = v.getLineCount()
        }
        if (value === 'edit') {
          const getLatestCount = v.getLineCount()
          return this.newLinesCount = getLatestCount
        }
      })
    }, 250)
  }
}
